import { styled } from '@linaria/react';

import { space } from '../theme/tokens';

export const CloseIconSlot = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${space[5]};
  height: ${space[5]};
`;
